import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-investment-info',
  templateUrl: './investment-info.component.html',
  styleUrls: ['./investment-info.component.scss']
})
export class InvestmentInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
